// Fetch list

export const FETCH = 'reportVehicleFuelings.FETCH'
export const FETCH_STARTED = 'reportVehicleFuelings.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportVehicleFuelings.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportVehicleFuelings.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportVehicleFuelings.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportVehicleFuelings.CLEAR'

// Export

export const EXPORT = 'reportVehicleFuelings.EXPORT'
export const EXPORT_FULFILLED = 'reportVehicleFuelings.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportVehicleFuelings.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportVehicleFuelings.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportVehicleFuelings.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportVehicleFuelings.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportVehicleFuelings.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportVehicleFuelings.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportVehicleFuelings.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportVehicleFuelings.EXPORT_DETAILS_FULFILLED'
